import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import * as Validation from "../../../../../constants/validation.constants";
import {CommonService} from "../../../../../services/common.service";
import {Subject, Subscription, takeUntil} from "rxjs";
import {UserProfileService} from "../../../services/user-profile.service";
import * as _ from "lodash";
import {dropDownOption} from "../../../../../constants/common.constants";
import {SaveAnswersRequest} from "../../../../../core/shared.actions";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../../../state/app.state";
import {saveAnswerInfo} from "../../../../../core/shared.selectors";

@Component({
  selector: 'app-editable-onboarding-details',
  templateUrl: './editable-onboarding-details.component.html',
  styleUrls: ['./editable-onboarding-details.component.css']
})
export class EditableOnboardingDetailsComponent implements OnInit {
  @Input() userDetails
  @Output() handleClick = new EventEmitter();
  loading: boolean = false;
  errorMessages: any = {};
  errorMessageMap = {
    'whatDoYouLikeToBeCalled_Other': {
      required: 'This field is required.'
    },
    'preferredLaguage_Other': {
      required: 'This field is required.'
    },
    'selfDescribe_Other': {
      required: 'This field is required.'
    },
    'medicalInsurance_Other': {
      required: 'This Field is required'
    },
    'undergraduateDegrees_Other': {
      required: 'This field is required.'
    },
    'masterDegrees_Other': {
      required: 'This field is required.'
    },
    'doctorateDegrees_Other': {
      required: 'This field is required.'
    },
    'professionalLicenses_Other': {
      required: 'This field is required.'
    },
    'organizationType_Other': {
      required: 'This field is required.'
    },
    'medication_Other': {
      required: 'This field is required.'
    },
    'medicalProblems_Other': {
      required: 'This field is required.'
    },
  }
  validation = Validation;
  form = new FormGroup({})
  obQuestions = [];
  otherPronounSelected: boolean = false;
  otherPreferredLanguageSelected: boolean = false;
  otherSelfDescribeSelected: boolean = false;
  otherMedicalInsuranceSelected: boolean = false;
  otherUnderGraduateDegreesSelected: boolean = false;
  otherMastersDegreesSelected: boolean = false;
  otherDoctorateDegreesSelected: boolean = false;
  otherOrganizationTypeSelected: boolean = false;
  otherProfessionalLicensesSelected: boolean = false;
  otherMedicationSelected: boolean = false;
  otherMedicalProblemsSelected: boolean = false;
  dataSub: Subscription = this.userProfileService.onBoardingQuestionData.subscribe((data: any) => {
    const obQuestions = _.cloneDeep(data) || [];
    this.obQuestions = _.cloneDeep(data) || [];
    if (obQuestions?.length) {
      obQuestions?.forEach(question => {
        this.errorMessageMap[`${question.questionKey}`] = {
          required: 'This field is required.'
        }
        this.form.addControl(`${question.questionKey}`, new FormControl({
          value: '',
          disabled: false
        }, [Validators.required]));
      })

      this.listenForValueChange(obQuestions);

      obQuestions?.map(o => {
        if (o.multiselectOptions?.length === 0) {
          if (o.answerType === 1) {
            const tempData = o['options']?.find((e) => e['key'] === o['selectedOptionId']);
            o['selectedOptionKey'] = tempData['key']

            const tempObj = {}
            tempObj[o['questionKey']] = tempData['key']

            this.form.patchValue({
              ...tempObj
            }, {emitEvent: true});
          }

          if (o.answerType === 4 || o.answerType === 3) {
            const tempObj = {}
            tempObj[o['questionKey']] = o['otherValue']

            this.form.patchValue({
              ...tempObj
            }, {emitEvent: true});
          }

        } else {
          const tempObj = {}
          tempObj[o['questionKey']] = o['multiselectOptions']
          this.form.patchValue({
            ...tempObj
          }, {emitEvent: true});
        }
      });
    }


  });
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private commonService: CommonService,
    private userProfileService: UserProfileService,
    private store: Store<fromRoot.State>,
  ) {
  }

  ngOnInit() {
    this.obQuestions = this.userDetails?.responses
    this.createObQuestionsSubscription(this.obQuestions);

    this.store.select(saveAnswerInfo)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.loading = data?.loading
      })

  }

  checkForErrors(currentField ?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  save() {
    if (this.form.invalid) {
      this.checkForErrors();
      return
    }

    const formValues = this.form.getRawValue();

    let userId;
    let payload;
    this.commonService.urlParams.subscribe(data => {
      const {params} = data;
      userId = params.clientAdminId || params.coachId || params.memberId;
    }).unsubscribe()

    if (userId) {
      payload = {
        forUserId: +userId,
        responses: []
      };
    } else {
      payload = {
        responses: []
      };
    }

    Object.keys(formValues).forEach(value => {
      const question = this.obQuestions.find(item => item.questionKey === value);
      const questionId = question?.questionId;
      const answerType = question?.answerType;
      
      if (Array.isArray(formValues[value])) {
        payload.responses.push({
          questionId: Number(questionId),
          multiselectOptions: formValues[value]
        })
      } else {
        if (typeof (formValues[value]) === "string" || answerType === 3 || answerType === 4) {
          if (value.includes('_Other')) {
            const separatedValue = value.split('_')[0]
            const questionId = this.obQuestions.find(item => item.questionKey === separatedValue)?.questionId
            payload.responses.forEach(e => {
              if (e.questionId === questionId) {
                e['otherValue'] = String(formValues[value])
              }
            })
          } else {
            payload.responses.push({
              questionId: Number(questionId),
              otherValue: String(formValues[value])
            });
          }
        } else {
          payload.responses.push({
            questionId: Number(questionId),
            selectedOptionKey: formValues[value]
          });
        }
      }
    })
    this.store.dispatch(SaveAnswersRequest({payload}));
    this.form.markAsPristine();
  }

  close() {
    this.handleClick.emit(false)
  }

  createObQuestionsSubscription(data) {
    this.userProfileService.onBoardingQuestionData.next(data);
  }

  getOtherValueForQuestion(data, questionKey) {
    const result = data.find(item => '' + item.questionKey === questionKey);
    return result?.otherValue || ''
  }

  listenForValueChange(obQuestions) {

    this.form.controls['whatDoYouLikeToBeCalled']?.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (data === dropDownOption.others) {
          this.otherPronounSelected = true
          this.form.addControl('whatDoYouLikeToBeCalled_Other', new FormControl({
            value: this.getOtherValueForQuestion(obQuestions, 'whatDoYouLikeToBeCalled'),
            disabled: false
          }, [Validators.required]));
        } else {
          this.otherPronounSelected = false
          this.form.removeControl('whatDoYouLikeToBeCalled_Other');
        }
      });

    this.form.controls['preferredLaguage']?.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (data === dropDownOption.others) {
          this.otherPreferredLanguageSelected = true
          this.form.addControl('preferredLaguage_Other', new FormControl({
            value: this.getOtherValueForQuestion(obQuestions, 'preferredLaguage'),
            disabled: false
          }, [Validators.required]));
        } else {
          this.otherPreferredLanguageSelected = false
          this.form.removeControl('preferredLaguage_Other');
        }
      });

    this.form.controls['selfDescribe']?.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (Array.isArray(data)) {
          this.otherSelfDescribeSelected = false
          this.form.removeControl('selfDescribe_Other');

          if (!data.includes(dropDownOption.preferNotToAnswer) && data.includes(dropDownOption.others)) {
            this.otherSelfDescribeSelected = true
            this.form.addControl('selfDescribe_Other', new FormControl({
              value: this.getOtherValueForQuestion(obQuestions, 'selfDescribe'),
              disabled: false
            }, [Validators.required]));
          }
        }
      });

    this.form.controls['medicalInsurance']?.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (Array.isArray(data)) {
          this.otherMedicalInsuranceSelected = false
          this.form.removeControl('medicalInsurance_Other');

          if (!data.includes(dropDownOption.preferNotToAnswer) && data.includes(dropDownOption.others)) {
            this.otherMedicalInsuranceSelected = true
            this.form.addControl('medicalInsurance_Other', new FormControl({
              value: this.getOtherValueForQuestion(obQuestions, 'medicalInsurance'),
              disabled: false
            }, [Validators.required]));
          }
        }
      });

    this.form.controls['undergraduateDegrees']?.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (Array.isArray(data)) {
          this.otherUnderGraduateDegreesSelected = false
          this.form.removeControl('undergraduateDegrees_Other');

          if (!data.includes(dropDownOption.preferNotToAnswer) && data.includes(dropDownOption.others)) {
            this.otherUnderGraduateDegreesSelected = true
            this.form.addControl('undergraduateDegrees_Other', new FormControl({
              value: this.getOtherValueForQuestion(obQuestions, 'undergraduateDegrees'),
              disabled: false
            }, [Validators.required]));
          }
        }
      });

    this.form.controls['masterDegrees']?.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (Array.isArray(data)) {
          this.otherMastersDegreesSelected = false
          this.form.removeControl('masterDegrees_Other');

          if (!data.includes(dropDownOption.preferNotToAnswer) && data.includes(dropDownOption.others)) {
            this.otherMastersDegreesSelected = true
            this.form.addControl('masterDegrees_Other', new FormControl({
              value: this.getOtherValueForQuestion(obQuestions, 'masterDegrees'),
              disabled: false
            }, [Validators.required]));
          }
        }
      });

    this.form.controls['doctorateDegrees']?.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (Array.isArray(data)) {
          this.otherDoctorateDegreesSelected = false
          this.form.removeControl('doctorateDegrees_Other');

          if (!data.includes(dropDownOption.preferNotToAnswer) && data.includes(dropDownOption.others)) {
            this.otherDoctorateDegreesSelected = true
            this.form.addControl('doctorateDegrees_Other', new FormControl({
              value: this.getOtherValueForQuestion(obQuestions, 'doctorateDegrees'),
              disabled: false
            }, [Validators.required]));
          }
        }
      });

    this.form.controls['professionalLicenses']?.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (Array.isArray(data)) {
          this.otherProfessionalLicensesSelected = false
          this.form.removeControl('professionalLicenses_Other');

          if (!data.includes(dropDownOption.preferNotToAnswer) && data.includes(dropDownOption.others)) {
            this.otherProfessionalLicensesSelected = true
            this.form.addControl('professionalLicenses_Other', new FormControl({
              value: this.getOtherValueForQuestion(obQuestions, 'professionalLicenses'),
              disabled: false
            }, [Validators.required]));
          }
        }
      });
    this.form.controls['organizationType']?.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (Array.isArray(data)) {
          this.otherProfessionalLicensesSelected = false
          this.form.removeControl('organizationType_Other');
          if (!data.includes(dropDownOption.preferNotToAnswer) && data.includes(dropDownOption.others)) {
            this.otherOrganizationTypeSelected = true
            this.form.addControl('organizationType_Other', new FormControl({
              value: this.getOtherValueForQuestion(obQuestions, 'organizationType'),
              disabled: false
            }, [Validators.required]));
          }
        }
      });

    this.form.controls['medication']?.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (data === dropDownOption.others) {
          this.otherMedicationSelected = true
          this.form.addControl('medication_Other', new FormControl({
            value: this.getOtherValueForQuestion(obQuestions, 'medication'),
            disabled: false
          }, [Validators.required]));
        } else {
          this.otherMedicationSelected = false
          this.form.removeControl('medication_Other');
        }
      });

    this.form.controls['medicalProblems']?.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (Array.isArray(data)) {
          this.otherMedicalProblemsSelected = false
          this.form.removeControl('medicalProblems_Other');
          if (!data.includes(dropDownOption.preferNotToAnswer) && data.includes(dropDownOption.others)) {
            this.otherMedicalProblemsSelected = true
            this.form.addControl('medicalProblems_Other', new FormControl({
              value: this.getOtherValueForQuestion(obQuestions, 'medicalProblems'),
              disabled: false
            }, [Validators.required]));
          }
        }
      });
  }

  ngOnDestroy() {
    this.dataSub.unsubscribe();
  }

}
